export default function TypeOfUsers({ hasBg }) {
  return (
    <>
      <div className="overflow-hidden">
        <section
          id="pricing"
          className={`package-section ${hasBg ? "gray-light-bg" : "background-shape-right"
            } ptb-100`}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="section-heading text-center mb-5">
                  <h2>
                    Canal de Ayuda por Tipo de Usuario <br />
                  </h2>
                  <p className="lead">
                    Tenemos un canal de Preguntas y Respuestas segun tu tipo de usuario
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md">
                <div className="card text-center single-pricing-pack p-5">
                  <h5 className="mb-2">Usuario</h5>
                  <div className="pricing-img mt-3 mb-4">
                    <img
                      src="assets/img/basic.svg"
                      alt="pricing img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="card-body p-0">
                    <ul className="list-unstyled text-sm pricing-feature-list">
                      <li>5 Users access same time</li>
                      <li>Integrated eCommerce</li>
                      <li>Customization interface</li>
                      <li>Weekly updated</li>
                      <li>24/7 Phone Support</li>
                      <li>Event Analytics</li>
                    </ul>
                    <div className="py-4 border-0 pricing-header">
                      <div className="h1 text-center mb-0 color-secondary">
                        $<span className="price font-weight-bolder">29</span>
                      </div>
                    </div>
                    <a href="#/" className="btn outline-btn" target="_blank">
                      Purchase now
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md">
                <div className="card text-center popular-price single-pricing-pack p-5">
                  <h5 className="mb-2">Creadores</h5>
                  <div className="pricing-img mt-3 mb-4">
                    <img
                      src="assets/img/standard.svg"
                      alt="pricing img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="card-body p-0">
                    <ul className="list-unstyled text-sm pricing-feature-list">
                      <li>10 Users access same time</li>
                      <li>Integrated eCommerce</li>
                      <li>Customization interface</li>
                      <li>Daily updated</li>
                      <li>24/7 Phone Support</li>
                      <li>Event Analytics</li>
                    </ul>
                    <div className="py-4 border-0 pricing-header">
                      <div className="h1 text-center mb-0 color-secondary">
                        $<span className="price font-weight-bolder">145</span>
                      </div>
                    </div>
                    <a href="#/" className="btn solid-btn" target="_blank">
                      Purchase now
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md">
                <div className="card text-center single-pricing-pack p-5">
                  <h5 className="mb-2">Agencias / Productoras</h5>
                  <div className="pricing-img mt-3 mb-4">
                    <img
                      src="assets/img/unlimited.svg"
                      alt="pricing img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="card-body p-0">
                    <ul className="list-unstyled text-sm pricing-feature-list">
                      <li>20 Users access same time</li>
                      <li>Integrated eCommerce</li>
                      <li>Fully Customization interface</li>
                      <li>Free updated</li>
                      <li>24/7 Phone Support</li>
                      <li>Event Analytics</li>
                    </ul>
                    <div className="py-4 border-0 pricing-header">
                      <div className="h1 text-center mb-0 color-secondary">
                        $<span className="price font-weight-bolder">249</span>
                      </div>
                    </div>
                    <a href="#/" className="btn outline-btn" target="_blank">
                      Purchase now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5 text-center">
              <p className="mb-2">
                Si necesitas hablar con nuestro soporte tecnico ingresa a la app y presiona en tu menu lateral Asesoramiento sino 
                <a href="/" className="color-secondary">
                  {" "}
                  Contactanos{" "}
                </a>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
